export default class PaJobLevelRecordController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paJobLevelRecord/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paJobLevelRecord/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/paJobLevelRecord/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paJobLevelRecord/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paJobLevelRecord/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paJobLevelRecord/delete', 'post', params, axiosOption, httpOption);
  }
}
